/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { JcsDetailsDto } from './job-color-selection.dto';

export const JcsDetailsMapper = entity<JcsDetailsDto>({
  csSignedByClientDate: date(DateFormat.Date),
  csSignedByOfficeDate: date(DateFormat.Date),
});
